import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'campaignType', method: 'GET', body: null, token: token })
}
